import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation, HostListener } from '@angular/core';
import { WebSiteService } from './services/website-service';

@Component({
  selector: 'm-website',
  templateUrl: './website.component.html',

  
  styleUrls: [
    './website.component.scss',
    '../../assets/website/css/material.css',
    '../../assets/website/css/demo.css',
    '../../assets/website/fonts/fonts.css',
    '../../assets/website/css/vertical-nav.css',
  ],
  encapsulation: ViewEncapsulation.None
})
export class WebsiteComponent implements OnInit {
  isMenuFixed = true;

  constructor()
  { }

  ngOnInit() {

  }

   @HostListener('window:scroll')
   onscroll() {
     this.isMenuFixed = window.scrollY < 70;
   }
}
